import React from "react";
import { Link } from "react-router-dom";
import "../css/breadcrumb.css";
import { ReactComponent as LeftIcon } from "../assets/icons/left_arrow.svg";
import { ReactComponent as DotIcon } from "../assets/icons/dot.svg";
import {Button} from "../elements/Button";

const Breadcrumbs = ({
  addCls,
  items, // Array of { label, link, className }
  additionalLinks = [],
  headerActions,
  p0 = false
}) => {
  const lastIndex = items.length - 1;

  return (
    <header className={`breadcrumb-header ${addCls ? addCls : ""} ${p0 === true ? `p0` : ``}`}>
      <span className="breadcrumb-title">
        <Link to={items[0]?.link || "/"}>
          <LeftIcon className="clickable vaMiddle" width={6} height={12} />
        </Link>
        &nbsp;
        {items.map((item, index) => (
          <React.Fragment key={index}>
            {index !== 0 &&items.length>2 && <DotIcon className="vaMiddle" />}
            {items.length > 2 && "\u2002\u00A0"}
            {item.link ? (
              <Link to={item.link}>
                {/* <label className={item.className}>{item.label}</label> */}
                  <label
                  className={`${item.className} ${
                    index === lastIndex ? "semibold-label" : ""
                  }`}
                >
                  {item.label}
                </label>

              </Link>
            ) : (
              // <label className={item.className}>{item.label}</label>
              <label
                className={`${item.className} ${
                  index === lastIndex ? "semibold-label" : ""
                }`}
              >
                {item.label}
              </label>
            )}
            &ensp;&nbsp;
          </React.Fragment>
        ))}
        {additionalLinks.map((item, index) => (
          <React.Fragment key={index}>
            {index !== 0  && <DotIcon className="vaMiddle" />}
            &ensp;&nbsp;
            {item.link ? (
              <Link to={item.link}>
                <label className={item.className}>{item.label}</label>
              </Link>
            ) : (
              <label className={item.className}>{item.label}</label>
            )}
            &ensp;&nbsp;
          </React.Fragment>
        ))}
      </span>

      <div className="breadcrumbs-actions">{headerActions}</div>
    </header>
  );
};

export default Breadcrumbs;
